<div mat-dialog-title> Editar Empresa</div>
<div [formGroup]="empresaForm" mat-dialog-content>
  <!-- Empresa -->
  <div class="row mt-3">
    <div class="col-5">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="CNPJ"
          disabled
          [value]="empresa ? helper.formatarCNPJ(empresa.cnpj) : ''"
          required
        >
        <mat-label>CNPJ</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-7">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="Nome Fantasia"
          formControlName="nome_fantasia"
          required
        >
        <mat-label>Nome Fantasia</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="Razão Social"
          formControlName="razao_social"
          required
        >
        <mat-label>Razão Social</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
  </div>
  <!-- Contato -->
  <div class="row">
    <div class="col-7">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="email"
          placeholder="Email"
          formControlName="email"
          required
        />
        <mat-label>Email</mat-label>
        <mat-error *ngIf="empresaForm.get('email').touched && empresaForm.get('email').hasError('invalidemail')">Email inválido</mat-error>
        <mat-error *ngIf="empresaForm.get('email').touched && empresaForm.get('email').hasError('required')">Campo obrigatório</mat-error>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-5">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="phone"
          placeholder="Telefone"
          formControlName="telefone"
          [mask]="empresaForm.get('telefone').value?.length <= 10 ? '(00) 0000-0*' : '(00) 0 0000-0000'"
          [validation]="false"
          required
        />
        <mat-error>Campo obrigatório</mat-error>
        <mat-label>Telefone</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
  </div>
  <!-- Endereço -->
  <div class="row mt-3">
    <div class="col-5">
      <app-busca-endereco
        icon="add"
        label="Consultar CEP"
        (endereco)="setEndereco($event)">
      </app-busca-endereco>
    </div>
    <div class="col-7">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="Logradouro"
          formControlName="logradouro"
          required
        >
        <mat-label>Logradouro</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-2">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="0000"
          disabled
          required
        >
        <mat-label>Número</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-6">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="Complemento"
          formControlName="complemento"
          required
        >
        <mat-label>Complemento</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-4">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="Bairro"
          formControlName="bairro"
          required
        >
        <mat-label>Bairro</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-6">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="Cidade"
          formControlName="cidade"
          disabled
          required
        >
        <mat-label>Cidade</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-5">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="Município"
          formControlName="municipio"
          required
        >
        <mat-label>Município</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-1">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="UF"
          formControlName="uf"
          required
        >
        <mat-label>UF</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
  </div>
  <!-- Representante -->
  <div class="row">
    <div class="col-3">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="000.000.000-000"
          mask="000.000.000-00"
          formControlName="cpf"
          required
        >
        <mat-label>CPF do Representante</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-7">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="Nome do Representante"
          formControlName="nome"
          required
        >
        <mat-label>Nome do Representante</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-2">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="text"
          placeholder="Tipo"
          formControlName="tipo"
        >
        <mat-label>Tipo</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
  </div>
  <!-- Contato do Representante -->
  <div class="row">
    <div class="col-7">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="email"
          placeholder="Email do Representante"
          formControlName="email_representante"
          required
        />
        <mat-label>Email do Representante</mat-label>
        <mat-error *ngIf="empresaForm.get('email_representante').touched && empresaForm.get('email_representante').hasError('invalidemail')">Email inválido</mat-error>
        <mat-error *ngIf="empresaForm.get('email_representante').touched && empresaForm.get('email_representante').hasError('required')">Campo obrigatório</mat-error>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
    <div class="col-5">
      <mat-form-field appearance="outline">
        <input
          matInput
          type="phone"
          placeholder="Telefone do Representante"
          formControlName="tel_representante"
          [mask]="empresaForm.get('tel_representante').value?.length <= 10 ? '(00) 0000-0*' : '(00) 0 0000-0000'"
          [validation]="false"
          required
        />
        <mat-error>Campo obrigatório</mat-error>
        <mat-label>Telefone do Representante</mat-label>
        <app-input-loading [isLoading]="loading"></app-input-loading>
      </mat-form-field>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="false" class="mr-3">
      Cancelar
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="closeDialog()"
      [disabled]="empresaForm.invalid"
    >
      Salvar
    </button>
  </div>
</div>
